import WepModal from '~comp/_common/wep-popup/WepModal.vue'
import WepAlertConfirmModal from '~comp/_common/wep-popup/WepAlertConfirmModal.vue'
import WepBrowserModal from '~comp/_common/wep-popup/WepBrowserModal.vue'
import WepSurveyModal from '~comp/_common/wep-popup/WepSurveyModal.vue'
import WepPolicyModal from '~comp/_common/wep-popup/WepPolicyModal.vue'
import WepCommModal from '~comp/_common/wep-popup/WepCommModal.vue'
import { uniqueId, remove } from 'lodash'

const WepPopupPlugin = {
  install (Vue) {
    Vue.component(WepModal.name, WepModal)
    var routerObj = window.vue.getInstance('router')
    var modalObjList = []
    routerObj.beforeEach((to, from, next) => {
      var isBack = Vue.prototype.$isBack(to)
      if (modalObjList.length > 0 && isBack) {
        var modalObj = modalObjList[modalObjList.length - 1].modal
        modalObj.modalCloseed()
        // modalObj.$destroy()
        next(false)
      } else {
        next()
      }
    })

    function removeModal (id) {
      if (id) {
        remove(modalObjList, { id: id })
      }
    }

    function fnBlur (isAlert) {
      if (isAlert) {
        document.activeElement.blur()
        document.querySelector('body').classList.add('popup-open')
      } else {
        document.querySelector('body').classList.remove('popup-open')
        let isScroll
        if (document.querySelectorAll('.popup-wrap').length >= 2) {
          document.querySelector('body').classList.add('popup-open')
          isScroll = false
        } else {
          isScroll = true
        }
        try {
          if (window.vue.getInstance('vue').$children[0].$children[0].$children[1].fnFullPageScroll !== undefined) {
            window.vue.getInstance('vue').$children[0].$children[0].$children[1].fnFullPageScroll(isScroll)
          } else if ( window.vue.getInstance('vue').$children[0].$children[0].$children[2].fnFullPageScroll !== undefined) {
            window.vue.getInstance('vue').$children[0].$children[0].$children[2].fnFullPageScroll(isScroll)
          }
        } catch (e) {
        }
      }
    }
    Vue.popup = Vue.prototype.$popup = {
      toast (message, options = {}) {
        var defaultOptions = {
          position: 'top-center',
          timeout: 2500,
          closeOnClick: false,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          showCloseButtonOnHover: false,
          closeButton: 'button',
          hideProgressBar: true,
          icon: {
            iconClass: 'popup_chk',
            iconChildren: '',
            iconTag: 'span'
          },
          rtl: false,
          toastClassName: '',
          bodyClassName: '',
          transition: 'Vue-Toastification__fade',
          onMounted: (e) => {
            console.log('onMounted :', e)
          }
        }
        // const contentObj = {
        //   // Your component or JSX template
        //   component: MmpToastTemplate,

        //   // Props are just regular props, but these won't be reactive
        //   props: {
        //     contents: message
        //   }
        // }

        Vue.$toast(message, Object.assign({}, defaultOptions, options))
        // <button class="popup_close" onClick={this.onClick}><span class="blind">닫기</span></button>
        // </div>
      },
      isModalActive () {
        return (modalObjList.length > 0)
      },
      alert (container, params) {
        fnBlur(true)
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_alert_')
          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, { isAlert: true }, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(WepAlertConfirmModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)
                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  fnBlur(false)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: alertProps
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      confirm (container, params) {
        fnBlur(true)
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_confirm_')

          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, { isAlert: false }, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(WepAlertConfirmModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  if (this.$options.dim) {
                    this.$options.rootContainer.appendChild(this.$options.dim)
                  }
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  if (this.$options.dim) {
                    document.body.appendChild(this.$options.dim)
                  }
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  fnBlur(false)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: alertProps
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      openModal (container, modalComponent, params) {
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_modal_')

          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(modalComponent).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.isValidParam !== undefined && this.isValidParam) {
                  if (this.$options.rootContainer) {
                    if (this.$options.dim) {
                      this.$options.rootContainer.appendChild(this.$options.dim)
                    }
                    this.$options.rootContainer.appendChild(this.$el)
                  } else {
                    if (this.$options.dim) {
                      document.body.appendChild(this.$options.dim)
                    }
                    document.body.appendChild(this.$el)
                  }
                } else {
                  this.modalCloseed()
                }
              },
              beforeDestroy () {
                if (this.isValidParam !== undefined && this.isValidParam) {
                  if (this.$options.dim) {
                    this.$el.parentNode.removeChild(this.$options.dim)
                  }
                  this.$el.parentNode.removeChild(this.$el)
                }

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  console.log(ev)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: params
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      browserLink (container, params) {
        fnBlur(true)
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_alert_')
          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, { isAlert: true }, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(WepBrowserModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  fnBlur(false)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: alertProps
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      WepPolicyModal (container, params) {
        fnBlur(true)
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_alert_')
          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, { isAlert: true }, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(WepPolicyModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  fnBlur(false)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: alertProps
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      WepSurveyModal (container, params) {
        fnBlur(true)
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_alert_')
          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, { isAlert: true }, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(WepSurveyModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  fnBlur(false)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: alertProps
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      WepCommModal (container, params) {
        fnBlur(true)
        return new Promise(function (resolve, reject) {
          var modalId = uniqueId('dynamic_alert_')
          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, { isAlert: true }, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(WepCommModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  fnBlur(false)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            rootContainer: document.getElementById('container'),
            propsData: alertProps
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      }
    }
  }
}

export default WepPopupPlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/WepPopup.js